import { z } from 'zod';
import { SystemSuggestionPayloadSchema, OrgFunctionSuggestionPayloadSchema } from '../../entities/entity-suggestion';
export const DuplicateCandidateReasonSchema = z.enum([
    'same_category',
    'same_department'
]);
export const DuplicateCandidateSchema = z.object({
    source: z.enum([
        'entity',
        'suggestion'
    ]),
    id: z.string(),
    score: z.number().min(0).max(1),
    reasons: z.array(DuplicateCandidateReasonSchema),
    preview: z.object({
        name: z.string(),
        secondaryLine: z.string().optional()
    })
});
const SystemQuery = z.object({
    kind: z.literal('system'),
    payload: SystemSuggestionPayloadSchema.partial().required({
        name: true
    })
});
const OrgFunctionQuery = z.object({
    kind: z.literal('orgFunction'),
    payload: OrgFunctionSuggestionPayloadSchema.partial().required({
        name: true
    })
});
export const DuplicateCandidatesRequestSchema = z.discriminatedUnion('kind', [
    SystemQuery,
    OrgFunctionQuery
]);
export const DuplicateCandidatesResponseSchema = z.object({
    data: z.array(DuplicateCandidateSchema)
});

//# sourceMappingURL=duplicate-candidates.contract.js.map